import { http } from '../utils/http'

const searchAction = (params,page,size) => {
  const url = `/api/v1/users/page?pageNo=${page-1}&pageSize=${size}`
  return http.post(url, params)
};
const addAction = (params) => {
  const url = '/api/v1/users/add'
  return http.post(url, params)
};
const roleAction = (params,id) => {
  const url = `/api/v1/users/${id}/roles/bind`
  return http.post(url, params)
};
const getRoleAction = () => {
  const url = '/api/v1/roles'
  return http.post(url)
};
const statusAction = (params,id) => {
  const url = `/api/v1/users/${id}/update`
  return http.post(url,params)
};
const updatePwdBySystem = (params) => {
  const url = '/api/v1/sso/updatePwdBySystem'
  return http.post(url, params)
};
const searchPassword = () => {
  const url = '/api/v1/sso/get/global/password'
  return http.post(url)
};
const generatePassword = (params) => {
  const url = '/api/v1/sso/generate/global/password'
  return http.post(url, params)
};
const clawBotStatus = id => http.get(`/api/v1/users/${id}/clawbot`);
const clawBotPair = id => http.post(`/api/v1/users/${id}/clawbot/pair`);
const clawBotVerify = (id, code) => http.post(`/api/v1/users/${id}/clawbot/verify`, {code});
const clawBotEnable = id => http.post(`/api/v1/users/${id}/clawbot/enable`);
const clawBotDisable = id => http.post(`/api/v1/users/${id}/clawbot/disable`);
const clawBotUnbind = id => http.post(`/api/v1/users/${id}/clawbot/unbind`);
export default {
  searchAction,
  addAction,
  roleAction,
  getRoleAction,
  statusAction,
  updatePwdBySystem,
  searchPassword,
  generatePassword,
  clawBotStatus,
  clawBotPair,
  clawBotVerify,
  clawBotEnable,
  clawBotDisable,
  clawBotUnbind
}
